var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.9 55.1"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.6 34.7a10.27 10.27 0 00-8.4 4.4l-17.5-8.4a11.06 11.06 0 00.7-3.7 11.27 11.27 0 00-.5-3.2L37 15.6A10.22 10.22 0 1045.7 0a10.35 10.35 0 00-10.3 10.3c0 .5.1 1 .1 1.5l-17.6 8.6a10 10 0 00-7.7-3.5 10.2 10.2 0 000 20.4 10.12 10.12 0 007.4-3.2l18.1 8.8a13.55 13.55 0 00-.2 2 10.2 10.2 0 1010.1-10.2z"
  })));
}

export default __webpack_public_path__ + "static/media/share.fcd9dbbdeb71b170183a943cb2ebf2bf.svg";
export { SvgShare as ReactComponent };